import(/* webpackMode: "eager" */ "/home/runner/work/aviva-digital/aviva-digital/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/aviva-digital/aviva-digital/components/Chatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/aviva-digital/aviva-digital/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/aviva-digital/aviva-digital/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/aviva-digital/aviva-digital/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/aviva-digital/aviva-digital/components/MotionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/aviva-digital/aviva-digital/components/PublicChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/runner/work/aviva-digital/aviva-digital/lib/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/aviva-digital/aviva-digital/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Tenor_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"variable\":\"--font-display\",\"display\":\"swap\"}],\"variableName\":\"tenorSans\"}");
